import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-[rgba(255,255,255,0.06)] py-16 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo */}
        <AppLogo size={24} iconName="BoltIcon" text="Invoice" className="text-white" />

        {/* Links */}
        <div className="flex items-center gap-8 text-[13px] font-medium text-[#C0C7D0]">
          <a href="#features" className="hover:text-white transition-colors">Features</a>
          <a href="#integrations" className="hover:text-white transition-colors">Integrations</a>
          <a href="#pricing" className="hover:text-white transition-colors">Pricing</a>
          <a href="#" className="hover:text-white transition-colors">Privacy</a>
          <a href="#" className="hover:text-white transition-colors">Terms</a>
        </div>

        {/* Social + copyright */}
        <div className="flex items-center gap-4">
          <a
            href="#"
            aria-label="Twitter"
            className="w-9 h-9 rounded-full border border-[rgba(255,255,255,0.1)] flex items-center justify-center text-[#C0C7D0] hover:border-teal hover:text-teal transition-all"
          >
            <Icon name="GlobeAltIcon" size={16} />
          </a>
          <a
            href="#"
            aria-label="LinkedIn"
            className="w-9 h-9 rounded-full border border-[rgba(255,255,255,0.1)] flex items-center justify-center text-[#C0C7D0] hover:border-teal hover:text-teal transition-all"
          >
            <Icon name="LinkIcon" size={16} />
          </a>
          <span className="text-[12px] text-[#C0C7D0] opacity-50 ml-2">© 2026 Invoice</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;